import {
  Container,
  Flex,
  Text,
  Title,
  createStyles,
  rem,
  SimpleGrid,
  Group,
  Button,
} from "@mantine/core";
import { marathons } from "./config";
import { DirectionCard } from "shared/ui/DirectionCard";
import React from "react";
import { wrapUrlWithCurrentQuery } from "common";

const useStyles = createStyles((theme) => ({
  inner: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontWeight: 700,
    fontSize: "3rem",

    [theme.fn.smallerThan("md")]: {
      fontSize: "2.5rem",
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: "2rem",
    },
  },

  highlight: {
    position: "relative",
    color: theme.white,
    background: theme.fn.variant({
      variant: "gradient",
      gradient: { from: "indigo", to: "cyan" },
    }).background,
    borderRadius: theme.radius.sm,
    padding: `${rem(4)} ${rem(12)}`,
    lineHeight: rem(72),
  },

  container: {
    marginBottom: 48,

    [theme.fn.smallerThan("md")]: {
      marginBottom: 32,
    },

    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
    },

    [theme.fn.smallerThan("xs")]: {
      marginBottom: 24,
    },
  },

  button: {
    marginTop: `calc(${theme.spacing.xl} * 2)`,

    [theme.fn.smallerThan("md")]: {
      marginTop: rem(32),
    },

    [theme.fn.smallerThan("xs")]: {
      marginTop: theme.spacing.xl,
    },
  },
}));

export function FreeCourses(): React.JSX.Element {
  const { classes } = useStyles();

  return (
    <Container size="xl" className={classes.inner}>
      <Flex
        align="flex-start"
        justify="space-between"
        className={classes.container}
      >
        <Title className={classes.title}>
          <span className={classes.highlight}>Бесплатные</span> учебные марафоны
        </Title>
        <Text mt="md" maw={340} size="md" c="dimmed">
          Ознакомительные учебные курсы с получением сертификата и кураторской
          поддержкой
        </Text>
      </Flex>
      <SimpleGrid
        cols={3}
        spacing="xl"
        breakpoints={[
          { maxWidth: "lg", cols: 2 },
          { maxWidth: "md", cols: 1 },
        ]}
      >
        {marathons.map((item, index) => (
          <DirectionCard key={index} {...item} />
        ))}
      </SimpleGrid>

      <Group position="center" className={classes.button}>
        <Button
          variant="light"
          radius="xl"
          size="md"
          component="a"
          target="_blank"
          href={wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/training/category/besplatnoe-obuchenie")}
        >
          Показать ещё интенсивы
        </Button>
      </Group>
    </Container>
  );
}
